import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../api/client";
import { WORKSPACES_KEY } from "../api/hooks/useWorkspaces";
import type { Workspace } from "../api/types";

interface CreateWorkspaceInput {
  readonly name: string;
  /** Omit to let the server derive one from the name, stepping past reserved
   *  and already-taken slugs. Send it only when the user chose it. */
  readonly slug?: string;
}

export function useCreateWorkspace() {
  const qc = useQueryClient();
  return useMutation<Workspace, ApiError, CreateWorkspaceInput>({
    mutationFn: (input) =>
      apiFetch<Workspace>("/api/workspaces", { method: "POST", body: input }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: WORKSPACES_KEY });
    },
  });
}
